import { FC } from 'react';
import { DashboardConnectorType } from '../../../models/StudentDashboard';
import { useAppSelector } from '../../../redux/hooks';
import { selectedUnit } from '../../../redux/reducers/unitSlice';
import {
  lockedHeaderBadgeColors,
  resolveUnitBaseColor,
  unitHeaderBadgeColors,
} from '../../../businessLogicService/StudentDashboardAux/getColorByUnit';
import { UnitHeaderFoundationsIcon } from '../DashboardUnitHeaderIcons/UnitHeaderFoundationsIcon';

interface Props {
  type: DashboardConnectorType;
}

export const FoundationsMilestoneBadge: FC<Props> = ({ type }) => {
  const unit = useAppSelector(selectedUnit);
  const colors = type === 'locked' ? lockedHeaderBadgeColors : unitHeaderBadgeColors[resolveUnitBaseColor(unit?.name)];

  return (
    <div className="tw-relative tw-h-[85px] tw-w-[80px]">
      <svg
        className="tw-absolute tw-left-0 tw-top-[58px]"
        width="80"
        height="30"
        viewBox="0 0 80 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse className={colors.archShadow} cx="40" cy="15" rx="40" ry="15" />
      </svg>
      <UnitHeaderFoundationsIcon
        className="tw-absolute tw-left-1/2 tw-top-[24px] tw-h-[62px] tw-w-auto tw--translate-x-1/2"
        colors={colors}
      />
    </div>
  );
};
